import React from "react";
import { Col, Row, Button, Layout } from "antd";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
// component
import SectionTitle from "../../component/section_title";
//redux
import { logOut } from "../../store/auth/auth.action";

const { Content } = Layout;

const RequireScreen = () => {
  // -------------------------- VAR --------------------------
  const { t } = useTranslation("translation", { keyPrefix: "verification" });
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  const renderBody = () => {
    return (
      <Row justify="center" align="middle" gutter={[16, 16]}>
        <Col xl={24} lg={24} md={24} xs={24}>
          <p style={{ textAlign: "center", color: "red" }}>
            This page requires admin account to continue.
          </p>
        </Col>
        <Row justify="end" align="middle" gutter={[16, 16]}>
          <Col>
            <Button onClick={() => dispatch(logOut())}>{t("logout")}</Button>
          </Col>
          <Col>
            <Button type="link" href="http://levietgroup.co.nz/">
              Ask Leviet Group
            </Button>
          </Col>
        </Row>
      </Row>
    );
  };

  const requireSection = () => {
    return (
      <Row align="center" style={{ margin: "40px 0px" }}>
        <Col align="center">
          <h1 style={{ fontSize: 30 }}>Require Access</h1>
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      {/* <LayoutBreadCrumb data={breadCrumb?.verification} /> */}
      <Content className="content">
        <Row gutter={[16, 16]} justify="center" style={{ marginBottom: 40 }}>
          <Col xxl={12} xl={12} lg={12} md={12} xs={12}>
            {requireSection()}
            {renderBody()}
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default RequireScreen;
